module.exports = __webpack_public_path__ + "static/media/MOBILE_L_standard_wynik.cc7bf77e.png";